import React from 'react';
const customers = [{
  name: 'Hextronics',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/hex-png.png',
  href: 'https://www.hextronics.com/'
}, {
  name: 'Octo Server',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/octoserver_dark.png',
  href: 'https://www.octoserver.com/'
}, {
  name: 'Crossbow Systems',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/xbow_dark.png',
  href: 'http://crossbowsystems.net/'
}, {
  name: 'FREDsense',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/fredsense_dark.png',
  href: 'https://fredsense.com/'
}, {
  name: 'N Line Energy',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/nline_dark.png',
  href: 'https://nlineenergy.com/'
}, {
  name: 'Blissway',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/blissway_dark.png',
  href: 'https://www.blissway.com/'
}, {
  name: 'Flexxbotics',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/flexxbotics_dark.png',
  href: 'https://flexxbotics.com/'
}, {
  name: 'Aclarity',
  logo: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/aclarity.png',
  href: 'https://aclarity.com/'
}];
export function CustomerLogos() {
  // Duplicate the list for seamless infinite scroll
  const allLogos = [...customers, ...customers];
  return <section id="social-proof" className="relative w-full bg-navy pt-4 pb-8 overflow-hidden" data-id="element-100">
      {/* Top subtle divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-101" />

      <p className="text-center text-white/30 text-sm font-medium tracking-[0.2em] uppercase mb-10" data-id="element-102">
        Trusted by innovative companies
      </p>

      {/* Marquee container */}
      <div className="relative" data-id="element-103">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-navy to-transparent z-10 pointer-events-none" data-id="element-104" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-navy to-transparent z-10 pointer-events-none" data-id="element-105" />

        <div className="flex animate-marquee" data-id="element-106">
          {allLogos.map((customer, index) => <a key={`${customer.name}-${index}`} href={customer.href} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 mx-12 flex items-center justify-center group" data-id="element-107">
              <img src={customer.logo} alt={customer.name} className="h-16 w-auto max-w-[240px] object-contain transition-all duration-300 cursor-pointer" style={{
            filter: customer.name === 'Hextronics' ? 'brightness(0) invert(1) opacity(0.4)' : 'brightness(0) invert(1) opacity(0.4)'
          }} onMouseEnter={e => {
            e.currentTarget.style.filter = 'brightness(0) invert(1) opacity(1) drop-shadow(0 0 12px rgba(255,255,255,0.4))';
          }} onMouseLeave={e => {
            e.currentTarget.style.filter = customer.name === 'Hextronics' ? 'brightness(0) invert(1) opacity(0.4)' : 'brightness(0) invert(1) opacity(0.4)';
          }} data-id="element-108" />
            </a>)}
        </div>
      </div>

      {/* Bottom subtle divider */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-109" />
    </section>;
}